import { useExportApi } from '../UseExportApi';
import { ExportChartOptions } from '../Model';
import { useCallback } from 'react';
import { FactRevenue, Option, PageName } from '@utils/pageConfig/Types';
import { exportBubbleChart } from './ExportBubbleChart';
import { KpiDataDto } from '@data-visualization/performance-analysis-line-chart/Types';
import { DEFAULT_VOLUME } from '@utils/factVolumeUtils/FactVolumeUtils';
import { useGetLoadedProductGroups } from '@hooks/export/UseGetLoadedProductGroups';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';

export interface ExportBubbleChartOptions extends ExportChartOptions {
  title: string;
  appliedCountry?: Option[];
  appliedPg?: Option[];
  data: KpiDataDto[];
  timePeriod: string;
  comparisonTimePeriod: string;
  factRevenue: FactRevenue;
  periodType: string;
  showPerformanceWithin: string;
  appliedFiltersText: string;
  selectedKpi: Option;
  segmentBy: string;
  volume?: string;
  pageName: PageName;
}

export function useExportBubbleChart(): {
  download: (options: ExportBubbleChartOptions) => Promise<void>;
} {
  const { exportFile: exportFn } = useExportApi();
  const pagesConfig = usePageConfig();
  const { loadedProductGroups } = useGetLoadedProductGroups();

  const download = useCallback(
    async (options: ExportBubbleChartOptions) => {
      const {
        exportFormats,
        invokeExport,
        title,
        appliedCountry,
        appliedPg,
        data,
        timePeriod,
        comparisonTimePeriod,
        factRevenue,
        periodType,
        showPerformanceWithin,
        appliedFiltersText,
        selectedKpi,
        segmentBy,
        volume = DEFAULT_VOLUME,
      } = options;

      await exportBubbleChart({
        exportFn,
        exportFormats,
        invokeExport,
        title,
        appliedCountry,
        appliedPg,
        data,
        timePeriod,
        comparisonTimePeriod,
        factRevenue,
        periodType,
        showPerformanceWithin,
        appliedFiltersText,
        selectedKpi,
        segmentBy,
        pageName: PageName.OPPORTUNITY_REVIEW,
        volume,
        pagesConfig,
        ...loadedProductGroups,
      });
    },
    [loadedProductGroups],
  );

  return {
    download,
  };
}
